"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isUndefined = function (value) {
    return value === undefined;
};
exports.default = isUndefined;
//# sourceMappingURL=is-undefined.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-undefined.js
// module id = 1127
// module chunks = 37